<template>
  <b-row>
    <b-col>
      <template v-if="loading">
        <loading />
      </template>
      <template v-else-if="isUserTypeInternal">
        <div class="login-container-new">
          <h5>{{ $t('loginPrompt') }}</h5>
          <b-form-input @input.native="personNotFound = false" v-model="loginId" id="login" :placeholder="$t('loginId')" />              
          <p v-if="personNotFound" class="ex">
            {{ $t('personNotFoundError') }}
          </p>
          <b-button
            :disabled="loginId === '' || !!authenticationError.errorMessage"
            variant="primary"
            @click="proceedWithLogin"
          >
            {{ $t('continue') }}
          </b-button>
        </div>
      </template>
      <template v-else>
        <div class="login-container">
          <h4>{{ title }}</h4>
          <div class="error-message">
            <h5>{{ authenticationError.errorMessage }}</h5>
            <div class="stack-trace">
              {{ authenticationError.errorStack }}
            </div>
          </div>
        </div>
      </template>
    </b-col>
  </b-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapMutations } from 'vuex'
import Loading from './Loading'
let locale = 'en'

export default {
  name: 'Login',
  components: {
    'loading': Loading
  },
  data () {
    return {
      title: 'User Authentication Failed!',
      loading: false,
      isUserTypeInternal: false,
      isla007User: false,
      loginId: '',
      authCookie: process.env.AUTH_COOKIE || '',
      authServiceURL: this.UrlBuilder.authenticationUrl,
      personUrl: this.UrlBuilder.accountUrl,
      personNotFound: false,
      isInternal: window.location.host.includes('citrite.net')
    }
  },
  computed: {
    ...mapGetters(['isTokenAPICalled']),
    authenticationError () {
      return this.$store.getters.authenticationError
    },
    staticDirPrefix () {
      const devEnv = 'development'
      const env = process.env.NODE_ENV || devEnv
      return env === devEnv ? '' : '/licensingui'
    }
  },
  // perform authentication on component create (executed when user is not authenticated)
  mounted () {
    this.loading = true
    if (this.$route.params.hasEditRole !== 'undefined') {
      this.IS_PERSON_IN_ROLE(this.$route.params.hasEditRole === 'true')
    }
    Vue.AppInsights.trackPageView('Login page', '/login')
    // move the below to url builder or a config file
    if (!this.isTokenAPICalled) {
      this.IS_TOKEN_API_CALLED(true)
      this.$store.dispatch('authenticate', {
        authURL: this.authServiceURL,
        authCookie: this.authCookie,
        authService: this.authentication
      })
  .then(() => {
    if (this.isInternal) {
      this.isUserTypeInternal = true
      this.loading = false
      if (this.$store.getters.isLA007User === true) {
        this.$router.push('/la-007')
      }
      this.$store.commit('setLA007User', { value: false })
    } else {
      this.proceedWithLogin()
    }
    // pendo user identification hook
    if (!this.isInternal) {
      const { customerId, customerOrgId } = this.$store.getters.authToken
      try {
        const pendoObject = {
          visitor: {
            id: customerId
          },
          account: {
            id: customerOrgId
          }
        }
        const {PARENT_FRAME_URL} = process.env
        window.parent.postMessage(JSON.stringify(pendoObject), PARENT_FRAME_URL)
        window.pendo.initialize({
          visitor: {
            id: customerId
          },
          account: {
            id: customerOrgId
          }
        })
      } catch (e) {
        console.error('Pendo initialzation error')
      }
    }
  })
      .catch(this.handleError)
    } else {
      if (this.isInternal) {
        this.isUserTypeInternal = true
        this.loading = false
      }
    }
  },
  methods: {
    ...mapMutations([
      'IS_TOKEN_API_CALLED',
      'IS_PERSON_IN_ROLE'
    ]),
    handleError (error) {
      this.loading = false
      if (error.message === 'localeFetchFailed') {
        const path = this.$store.getters.previousPath
        this.$router.push(!path ? '/' : path)
      }
      if (error.message !== 'internalUser') {
        this.loggly.log({
          errorMessage: 'Login failed',
          errorObject: error,
          errorStack: error.stack
        })
      }
    },
    proceedWithLogin () {
      this.loading = true
      this.$store.dispatch('fetchPerson', {
        bottle: this.bottle,
        personUrl: this.UrlBuilder.accountUrl(encodeURIComponent(this.loginId))
      })
        .then(() => {
          const { customerId } = this.$store.getters.person
          this.personNotFound = !customerId
          if (!this.isUserTypeInternal) {
            locale = this.$store.getters.person.preferences.locale || locale
          }
          this.loggly.setUserId(customerId)
          if (!locale.includes('en')) {
            return this.$store.dispatch('fetchLocaleJson', {
              bottle: this.bottle,
              url: `${this.staticDirPrefix}/static/${locale}.json`
            })
            .catch(() => {
              throw new Error('localeFetchFailed')
            })
          }
          this.loading = false
          return Promise.resolve()
        })
        .then(() => {
          var path = this.$store.getters.previousPath
          const webkey = sessionStorage.getItem('webkey')
          if (!locale.includes('en')) {
            this.$i18n.setLocaleMessage(locale, this.$store.getters.localeJson)
            this.$i18n.locale = locale
          }
          this.loading = false
          if (path !== null) {
            if (path.startsWith('/login')) {
              path = '/'
            }
            this.$router.push(!path ? '/' : path)
          }

          if (webkey !== null) {
            this.$router.push(`/licenses?webkey=${webkey}`)
            sessionStorage.removeItem('webkey')
          }
        })
        .catch(this.handleError)
    }
  }
}
</script>

<style scoped>
.login-container {
  margin-top: 50px;
}

.login-container h4 {
  color: #990000;
}

.login-container .error-message {
  margin-top: 20px;
  padding: 10px;
  border: 1px solid #990000;
  background-color: #ffe6e6;
}

.login-container .error-message h5 {
  color: #990000;
}

.login-container .error-message .stack-trace {
  margin-top: 20px;
  color: #990000;
  font-style: italic;
}

.login-container-new {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100%;
  padding: 15px;
  top: 0;
  left: 0;
}

.login-container-new input {
  max-width: 300px;
  margin: 20px 20px;
}

p.ex {
  color: red;
  white-space: normal;
}

</style>



// WEBPACK FOOTER //
// src/components/Login.vue